import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA
} from "@angular/material/snack-bar";
import { environment } from "../../../environments/environment";
import { Area } from "../../engine/models/models";
import { Globals } from "../../services/globals";

@Component({
  selector: "app-notification-snackbar",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class NotificationComponent implements OnInit {
  selectedArea: Area;

  constructor(public globals: Globals,
    public _snackRef: MatSnackBarRef<NotificationComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: Area) {
    this.selectedArea = data;
  }

  ngOnInit() { }

  closeNotification() {
    this.selectedArea.helpTextHidden = true;
    this._snackRef.dismiss();
  }

  formatProfileImageUrl(url: string) {
    if (!url) return url;
    if (url.includes("http") || url.includes("assets")) return url;
    return environment.userProfileImage + this.encode(url);
  }

  encode(imageUrl: string): string {
    return imageUrl.replace(/\(/g, "%28").replace(/\)/g, "%29");
  }
}
